import { CookieUtils } from '@marriott/mi-ui-library';

export const COOKIE_SESSION_ID = 'sessionID';
export const COOKIE_MI_SITE = 'MI_SITE';
export const COOKIE_RELEASE_VERSION = 'x-mi-tag';

export const parseBoolean = (bool: string) => {
  if (bool) {
    return JSON.parse(bool?.toLowerCase());
  } else return false;
};

export class FooterSessionID {
  ref: HTMLElement;

  constructor(comp: Element) {
    this.ref = <HTMLElement>comp;
  }

  initialize(): void {
    const sessionId = CookieUtils.getCookie(COOKIE_SESSION_ID) || '';
    const miSite = CookieUtils.getCookie(COOKIE_MI_SITE) || '';
    const releaseVersion = CookieUtils.getCookie(COOKIE_RELEASE_VERSION) || '';
    if (sessionId) {
      const listOfIds = [miSite, sessionId, releaseVersion];
      this.ref.innerHTML = listOfIds.filter(id => id).join(',');
    }
  }
}

export const initializeFooterId = () => {
  const sessionID = document.querySelector('.js-session-detail');
  if (sessionID) {
    new FooterSessionID(sessionID).initialize();
  }
};
